import type { License as LicenseModel } from '@/adapters/catalogv1.g';

/**
 * Transform a backend License model to a frontend CatalogLicense type.
 * @param model - API License response from catalog
 * @returns CatalogLicense - UI-friendly License object
 */
export function extractLicense(model: LicenseModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.license_ref ?? '',
    productName: model.product_name ?? '',
    sku: model.sku,
    status: model.status,
    totalUnits: model.total_units,
    consumedUnits: model.consumed_units,
    servicePlans: model.service_plans ?? [],
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogLicense = ReturnType<typeof extractLicense>;
